var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSmArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right 1",
    clipPath: "url(#clip0_345_8786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.59897 2.2936C7.09975 1.86178 6.34169 1.91222 5.90532 2.4058C5.46938 2.89981 5.52036 3.64996 6.01914 4.08179L14.5867 11.4998L6.0187 18.9183C5.51948 19.3501 5.46894 20.1002 5.90488 20.5938C6.34125 21.0878 7.09931 21.1383 7.59853 20.7064L17.1984 12.3939C17.459 12.1686 17.6084 11.8425 17.6084 11.4998C17.6084 11.1571 17.459 10.8314 17.1984 10.6057L7.59897 2.2936Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_8786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.608398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSmArrow);
export default __webpack_public_path__ + "static/media/right-sm-arrow.840e0ca19e0a14aa04894405daead320.svg";
export { ForwardRef as ReactComponent };